import { Button } from "@/components/Button/Button";
import { HiddenInput } from "@/components/HiddenInput/HiddenInput";
import { UploadSvg } from "@/components/Icon/Icon";
import { allowedModelFileTypes } from "@/typed/ModelFileTypes";
import { ChangeEvent, MouseEventHandler, ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface CaseUploadButtonProps {
  variant?: "text" | "contained" | "outlined";
  marginTop?: string;
  iconOnly?: boolean;
  textOnly?: boolean;
  secondary?: boolean;
}

const BaseCaseUploadButton = ({
  marginTop = "0",
  variant = "contained",
  iconOnly = false,
  textOnly = false,
  secondary = false,
  children,
  onClick
}: CaseUploadButtonProps & { children: ReactNode; onClick?: MouseEventHandler<HTMLButtonElement> }) => {
  return (
    <Button
      component="label"
      variant={variant}
      startIcon={!iconOnly && !textOnly && <UploadSvg color="inherit" />}
      color={secondary ? "secondary" : "primary"}
      sx={{
        marginTop: marginTop,
        textDecoration: "underline",
        fontSize: "1rem",
        paddingX: "10px"
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export const NewEmptyCaseUploadButton = (props: CaseUploadButtonProps & { onClick: MouseEventHandler<HTMLButtonElement> }) => {
  const { t } = useTranslation("cases");
  return <BaseCaseUploadButton {...props}>{t("button.newCase")}</BaseCaseUploadButton>;
};

export const CaseUploadButton = ({
  acceptDirectory = true,
  buttonFunction,
  iconOnly = false,
  ...props
}: CaseUploadButtonProps & { acceptDirectory?: boolean; buttonFunction?: (e: ChangeEvent<HTMLInputElement>) => any }) => {
  const { t } = useTranslation("cases");
  const message = acceptDirectory ? t("button.browseDirectories") : t("button.browseFiles");

  return (
    <BaseCaseUploadButton {...props} iconOnly={iconOnly}>
      <HiddenInput
        multiple={true}
        type="file"
        acceptDirectory={acceptDirectory}
        onChange={buttonFunction}
        {...(acceptDirectory ? {} : { accept: allowedModelFileTypes.join(",") })}
      />
      {iconOnly ? <UploadSvg color="inherit" /> : message}
    </BaseCaseUploadButton>
  );
};
